export default __webpack_public_path__ + "static/media/add-folder.54a04521.svg";